if (!customElements.get('nps-size-guide')) {
  customElements.define('nps-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-nps-size-open]');
      const closer = this.querySelector('[data-nps-size-close]');
      if (!dialog || !opener || !closer) return;
      opener.addEventListener('click', () => dialog.showModal());
      closer.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => opener.focus());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    }
  });
}
